import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { HERO_VIDEO } from '../../data';

const VideoModal = ({ isOpen, onClose }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[60] bg-black flex items-center justify-center p-4 md:p-20"
                >
                    <button onClick={onClose} className="absolute top-8 right-8 text-white p-4 border border-white/20 rounded-full hover:bg-white hover:text-black transition-all">
                        <X />
                    </button>
                    <video src={HERO_VIDEO} controls autoPlay className="w-full h-full object-contain" />
                </motion.div>
            )}
        </AnimatePresence>
    );
};
export default VideoModal;
